import Vue from 'vue'
import VueMoment from 'vue-moment'

Vue.use(VueMoment)

import router from './router'
import store from './store'
import api from './api'
import pop from './pop'

import './components'
import App from './App.vue'

// Import global style
import './style/main.styl'

// Link store to api
api.setStore(store)

Vue.config.productionTip = false

new Vue({
	router,
	store,
	api,
	pop,
	render: h => h(App)
}).$mount('#app')
